import logo from './logo.svg';
import './App.css';
import ChatPage from './COMP/Pages/ChatPage';

function App() {
  return (
    <div className="App">
      <ChatPage/>
    </div>
  );
}

export default App;
